import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PatientService } from '../../services/patient.service';
import { SharedModule } from '../../shared/shared.module';
import { MatCardModule } from '@angular/material/card';

import { switchMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import {
  NavigationItem,
  navigationItemsNoPatient,
} from '../../models/navigation-item-model';
import { PatientOverviewComponent } from './patient-overview/patient-overview.component';
import { AppointmentAnalysisComponent } from './appointment-analysis/appointment-analysis.component';
import { MatIconModule } from '@angular/material/icon';
import { AiService } from '../../services/ai.service';
import { ActivePatientFieldsForAiAnalysis } from '../../models/patient-model';
import { MatButtonModule } from '@angular/material/button';
import { classes, pages } from '../../shared/labels';
@Component({
  selector: 'app-patient-ai-analysis',
  standalone: true,
  templateUrl: './patient-ai-analysis.component.html',
  styleUrls: ['./patient-ai-analysis.component.scss'],
  imports: [
    SharedModule,
    MatCardModule,
    PatientOverviewComponent,
    AppointmentAnalysisComponent,
    MatIconModule,
    MatButtonModule,
  ],
})
export class PatientAiAnalysisComponent implements OnInit {
  selectedPatient: ActivePatientFieldsForAiAnalysis =
    {} as ActivePatientFieldsForAiAnalysis;
  navigationItems: NavigationItem[];

  isMobile: boolean = window.innerWidth < 730;
  patientId: string = '';
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private patientService: PatientService,
    private aiService: AiService
  ) {
    this.navigationItems = navigationItemsNoPatient.map((item) => {
      if (item.label === pages.aiAnalyses) {
        return { ...item, class: classes.hb };
      }
      return { ...item };
    });
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.patientId = params['patientId'];
      this.aiService.getPatientFieldsForAiAnalysis(this.patientId).subscribe({
        next: (patient) => {
          this.selectedPatient = patient;
        },
      });
    });
  }

  navigateBack(): void {
    this.router.navigate(['/analisi-ai']);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobile = window.innerWidth < 730;
  }
}
